import { BoardType, checkPlaceholders, getBoardRouteKey, replaceBoardId, replaceMeetingId } from "helpers";
import { environment } from "models/Environment";
import { getCurrentLanguage } from "providers";

class AppRoutes {
  static Home = "/";

  static Boards = "/boards";

  static Board = "/:boardId";

  static BoardMeetings = "/:boardId/meetings";

  static BoardSettings = "/:boardId/settings";

  static BoardMeeting = "/:boardId/meetings/:meetingId";

  static BoardMeetingAgendaItems = "/:boardId/meetings/:meetingId/agendaItems";

  static BoardMeetingParticipants = "/:boardId/meetings/:meetingId/participants";

  static BoardMeetingTasks = "/:boardId/meetings/:meetingId/tasks";

  static BoardMeetingDocuments = "/:boardId/meetings/:meetingId/documents";

  static BoardMeetingOneDriveSync = "/:boardId/meetings/:meetingId/oneDrive";

  static NotFound = "/*";

  static getBackgroundClass(pathname: string) {
    return pathname == "gugus" ? "has-background" : "";
  }

  static toBoards() {
    return this.Boards;
  }

  static toBackendAuditLog(entityName: string, entityId: string | number) {
    return this.getBackendUrl(`/auditLog/${entityName}/${entityId}`);
  }

  static toBackendAdmin() {
    return this.getBackendUrl(`/admin`);
  }

  static toBackendUserDetail(userId?: string) {
    return this.getBackendUrl(`/users/${userId}`);
  }

  static toBackendAbout(): string | undefined {
    return this.getBackendUrl(`/about`);
  }

  static getBackendUrl(path: string, includeCulture: boolean = true) {
    if (!path.startsWith("/")) {
      path = `/${path}`;
    }

    path = `${environment.backendUrl}${path}`;
    if (includeCulture) {
      const lang = getCurrentLanguage();
      path = path.includes("?") ? `${path}&culture=${lang}` : `${path}?culture=${lang}`;
    }

    return path;
  }

  static toBoardSettings(boardId: BoardType) {
    let url = this.BoardSettings;
    url = replaceBoardId(url, boardId);
    checkPlaceholders(url);
    return url;
  }

  static toBoardMeetings(boardId: BoardType) {
    let url = this.BoardMeetings;
    url = replaceBoardId(url, boardId);
    checkPlaceholders(url);
    return url;
  }

  static toBoardMeeting(meetingId: number, boardId: BoardType) {
    let url = this.BoardMeeting;
    url = replaceBoardId(url, boardId);
    url = replaceMeetingId(url, meetingId);
    checkPlaceholders(url);
    return url;
  }

  static toBoardMeetingAgendaItems(meetingId: number, boardId: BoardType) {
    let url = this.BoardMeetingAgendaItems;
    url = replaceBoardId(url, boardId);
    url = replaceMeetingId(url, meetingId);
    checkPlaceholders(url);
    return url;
  }

  static toBoardMeetingParticipants(meetingId: number, boardId: BoardType) {
    let url = this.BoardMeetingParticipants;
    url = replaceBoardId(url, boardId);
    url = replaceMeetingId(url, meetingId);
    checkPlaceholders(url);
    return url;
  }

  static toBoardMeetingOneDriveSync(meetingId: number, boardId: BoardType) {
    let url = this.BoardMeetingOneDriveSync;
    url = replaceBoardId(url, boardId);
    url = replaceMeetingId(url, meetingId);
    checkPlaceholders(url);
    return url;
  }

  static toBoardMeetingDocuments(meetingId: number, boardId: BoardType) {
    let url = this.BoardMeetingDocuments;
    url = replaceBoardId(url, boardId);
    url = replaceMeetingId(url, meetingId);
    checkPlaceholders(url);
    return url;
  }

  static toDocumentDownload(documentId: number, boardId: BoardType) {
    if (documentId <= 0) return null; // this can be null if confidential permission is false for current user.
    const boardRouteId = getBoardRouteKey(boardId);
    return `/api/${boardRouteId}/workingDocuments/${documentId}`;
  }

  static toBoardMeetingTasks(meetingId: number, boardId: BoardType) {
    let url = this.BoardMeetingTasks;
    url = replaceBoardId(url, boardId);
    url = replaceMeetingId(url, meetingId);
    checkPlaceholders(url);
    return url;
  }

  static toDetailDashboard() {
    return undefined;
  }
}

export default AppRoutes;
